export default (theme: Object) => ({
  avatar: {
    height: '33px',
    marginLeft: '8px',
    width: '33px',
  },
  icon: {
    height: '24px',
    marginLeft: '4px',
    width: '24px',
  },
  userName: {
    color: theme.palette.neutrals.secondaryText,
    fontWeight: 'normal',
    textTransform: 'none',
    lineHeight: '18px',
    fontSize: '14px',
  },
  dropDownMenu: {
    width: '190px',
  },
  menuItemLink: {
    color: theme.palette.neutrals.secondaryText,
    textDecoration: 'none',
  },
  roleSectionIntro: {
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing.unit,
    paddingTop: theme.spacing.unit * 1.5,
    paddingBottom: theme.spacing.unit * 0.5,
    cursor: 'default',
    opacity: 1,
    '&.Mui-disabled': {
      opacity: 1,
    },
  },
  roleSectionLabel: {
    fontSize: '11px',
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    color: theme.palette.text.secondary,
    lineHeight: 1.3,
  },
  roleMenuItem: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    textDecoration: 'none',
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    paddingLeft: theme.spacing.unit * 2 - 3,
    marginLeft: 0,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
});
